<template>
    <modal :id="modal" :name="modal" :width="'100%'" :height="'auto'" :scrollable="true" :adaptive="true" :close-on-backdrop="false" :close-on-esc="false" :click-to-close="false"
        styles="background-color: #AB1F08 !important; 
                margin-bottom: 60px !important;
                overflow-y: scroll; 
                max-width: 1000px; 
                margin: 0 auto;">
        <div class="button-close-position">
            <button class="button-close"
                @click="hideModal()">
                X
            </button>
        </div>
        <div v-if="modal=='lifetime-partner-modal'">
            <div class="mobile-display"  :style="loadMobileBg">
                <div class="bottom-0" :style="loadMobileHeader">
                </div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                </div>
                <div class="content banner-card padding-0">
                    <img v-bind:src="'images/mpower-new/award_recognition/lifetime_partner/content.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                    <div class="clear"></div>
                </div>
            </div>
            <!-- Ipad -->
            <div class="ipad-display" :style="loadTabletBg">
                <div class="bottom-0" :style="loadTabletHeader">
                    <!-- <img :src="'images/mpower-new/award_recognition/'+loadOverlapImage+'/iPad/header.png'" :style="loadOverlapTabletStyle" /> -->
                </div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font margin-bottom-0">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                </div>
                
                <div class="content banner-card padding-0">
                    <img :src="'images/mpower-new/award_recognition/lifetime_partner/iPad/content.png'" class="img-resize ipad">
                    <div class="clear"></div>
                </div>
            </div>
            <div class="modal-divider"></div>
        </div>
        <div v-else-if="modal=='national-awards-modal'">
            <!-- Mobile -->
            <div class="mobile-display"  :style="loadMobileBg">
                <div class="bottom-0" :style="loadMobileHeader"></div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font margin-bottom-0">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                </div>

                <div class="content banner-card padding-0">
                    <!-- <div class="content "> -->
                        <img v-bind:src="'images/mpower-new/award_recognition/national_awards/content.png'" class="responsive-image ipad-responsive-img mx-auto mobile padding-top-10">
                    <!-- </div> -->
                   
                    <div class="clear"></div>
                </div>
            </div>
            <!-- Ipad -->
            <div class="ipad-display" :style="loadTabletBg">
                <div class="bottom-0" :style="loadTabletHeader"></div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font line-height-32 margin-bottom-0">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                </div>
                <div class="content banner-card padding-0">
                        <img :src="'images/mpower-new/award_recognition/national_awards/iPad/content.png'" class="img-resize ipad">
                    <div class="clear"></div>
                </div>
            </div>
            <div class="modal-divider"></div>
        </div>
        <div v-else-if="modal=='million-dollar-modal'">
            <div class="mobile-display"  :style="loadMobileBg">
                <div class="bottom-0" :style="loadMobileHeader"></div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                </div>

                <div class="content banner-card padding-0">
                  
                        <img v-bind:src="'images/mpower-new/award_recognition/million_dollar/content.png'" class="responsive-image ipad-responsive-img mx-auto mobile padding-top-10">
                 
                   
                    <div class="clear"></div>
                </div>
            </div>
            <div class="ipad-display" :style="loadTabletBg">
                <div class="bottom-0" :style="loadTabletHeader"></div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font line-height-32 margin-bottom-0">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                </div>
                <div class="content banner-card padding-0">
                        <img :src="'images/mpower-new/award_recognition/million_dollar/iPad/content.png'" class="img-resize ipad">
                    <div class="clear"></div>
                </div>
            </div>
            <div class="modal-divider"></div>
        </div>
        <div v-else>
            <div class="mobile-display" :style="loadMobileBg">
                <div class="background-ovr bottom-0" :style="loadMobileHeader">
                    <!-- <img v-if="modal=='2027-mdrt-modal'" :src="'images/mpower/award/recruiter_league_logo.png'" :style="loadOverlapMobileStyle" /> -->
                </div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                    <div  v-if="modal=='2027-mdrt-modal'" class="desc-font">
                        Eligibility : Personal Sales (open to All Ranks)
                    </div>
                </div>

                <div class="content banner-card padding-0">
                    <img v-bind:src="'images/mpower-new/award_recognition/2027_mdrt/content.png'" class="responsive-image ipad-responsive-img mx-auto mobile">
                    <div class="clear"></div>
                </div>
            </div>
            <!-- Ipad -->
            <div class="ipad-display" :style="loadTabletBg">
                <div class="bottom-0" :style="loadTabletHeader"></div>
                <div class="content margin-top-30 text-left">
                    <div class="title-font line-height-32 margin-bottom-0">
                        {{title}}
                    </div>
                    <div class="desc-font">
                        {{description}}
                    </div>
                    <div  v-if="modal=='2027-mdrt-modal'" class="desc-font">
                        Eligibility : Personal Sales (open to All Ranks)
                    </div>
                </div>

                <div class="content banner-card padding-0">
                        <img :src="'images/mpower-new/award_recognition/2027_mdrt/iPad/content.png'" class="img-resize ipad">
                    <div class="clear"></div>
                </div>
            </div>
            <div class="modal-divider"></div>
        </div>
    </modal>
</template>
<style scoped>
.title-font {
    font-family: "HelveticaNeueLTStd-Bd";
    font-size: 32px;
    color: #fff;
    /* margin-bottom: 5px; */
}
.desc-font {
    font-size: 14px;
    color: #fff;
    line-height: normal;
}
.celebration-img {
    max-width: 167px;
    margin: 0 auto;
}
.celebration-img-tablet {
    max-width: 192px;
    margin: 0 auto;
}
.content.no-top{
    margin: 0px 15px 20px 15px!important;
}
.content.no-bottom{
    margin: 30px 15px 0px 15px!important;
}
.line-height-32 {
    line-height: 32px;
}
.width-69 {
    width: 69.5%;
}
.fixed-height {
    height: 205px;
}
.grid-bg {
    background : #2B2B2B;
}
.grid-title {
    font-weight : bold;
    font-size : 15px;
    color : #54D2E3;
    margin: 5px 0 5px 0;
}
.grid-description {
    font-size: 9px;
    color: rgb(255,255,255,0.7);
}
.grid-half {
    width: 49.5%;
    margin-right: 1%;
    float: left;
    height: 150px;
}
.tablet-grid-half {
    width: 24.8%;
    margin-right: 1px;
    float: left;
    height: 200px;
}
.tablet-grid-ovr-half {
    width: 24.9% !important;
}
.tablet-grid-half-left {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
}
.tablet-grid-half-right {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
}
.tablet-grid-icon-padding {
    padding: 30px 0;
}
.grid-half-top-left {
    border-top-left-radius: 15px;
}
.grid-half-top-right {
    border-top-right-radius: 15px;
}
.grid-half-bottom-left {
    border-bottom-left-radius: 15px;
}
.grid-half-bottom-right {
    border-bottom-right-radius: 15px;
}
.grid-half.last-column, .tablet-grid-half.grid-half.last-column {
    width: 49.5%;
    margin: 0% 0% 1% 0%;
    float: left;
}
.grid-image {
    margin: 0 auto;
    max-width: 50px;
}
.tablet-grid-image {
    max-width: 90px;
    margin: 0 auto;
}

.content {
        margin: 30px 30px 30px 30px!important;
    }

@media (max-width:575px){
    .title-font {
        font-size: 22px !important;
    }
    .desc-font {
        font-size: 12px !important;
    }
}
@media (min-width: 500px){
    .background-ovr {
        background-size: auto !important;
    }
}
@media (max-width: 325px){
    .content {
        margin: 30px 15px 20px 15px!important;
    }
}
.grid-award-img {
    max-width: 113px;
    margin: 0 auto;
}
</style>
<script>
export default {
    name: 'AwardBannerModal',
    props: {
        modal: String,
        title: String,
        positionSliderMobile: String,
        positionSliderIpad: String,
        image: String,
        overlapImage: String,
        description: String,
        backgroundSizeMobile: String,
        backgroundSizeIpad: String,
        backgroundPosition: String
    },
    computed: {
        loadModal(){
            return this.modal
        },
        loadTitle(){
            return this.title
        },
        loadSliderMobile(){
            if(this.modal!='lifetime-partner-modal'){
                return {
                    'position': 'absolute',
                    'bottom': '5px',
                    'right': '0',
                    'width': '40px'
                }
            }
            else{
                return {
                    'position': 'absolute',
                    'top': '5px',
                    'right': '0',
                    'width': '40px'
                }
            }
        },
        loadSliderTablet(){
            return {
                'position': 'absolute',
                'top': '0',
                'width': '60px',
                'left': '50%'
            }
        },
        loadOverlapMobileStyle(){
            if(this.modal=='2027-mdrt-modal'){
                return {
                    'position': 'absolute',
                    'top': '5%',
                    'left': '0',
                    'right': '0',
                    'margin': '0 auto',
                    'max-width': '174px'
                }
            }
            else{
                return {
                    'position': 'absolute',
                    'top': '25%',
                    'left': '0',
                    'right': '0',
                    'margin': '0 auto',
                    'max-width': '174px'
                }
            }
        },
        loadOverlapTabletStyle(){
            return {
                'position': 'absolute',
                'top': '20%',
                'right': '10%',
                'max-width': '300px'
            }
        },
        loadMobileHeader(){
            if(this.backgroundPosition!=""){
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/'+ this.overlapImage + '/header.png' + '\')',
                    'background-size': this.backgroundSizeMobile,
                    'background-repeat': 'no-repeat',
                    'background-position': 'left bottom',
                    'height': '210px'
                }
            }
            else{
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/'+ this.overlapImage + '/header.png' + '\')',
                    'background-size': this.backgroundSizeMobile,
                    'background-repeat': 'no-repeat',
                    'background-position': 'bottom',
                    'height': '210px'
                }
            }
        },
        loadTabletHeader(){
            if(this.backgroundPosition!=""){
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/'+ this.overlapImage + '/iPad/header.png' + '\')',
                    'background-size': this.backgroundSizeIpad,
                    'background-repeat': 'no-repeat',
                    'background-position': 'left bottom',
                    'height': '315px'
                }
            }
            else{
                return {
                    'backgroundImage':'url(\'images/mpower-new/award_recognition/'+ this.overlapImage + '/iPad/header.png' + '\')',
                    'background-size': this.backgroundSizeIpad,
                    'background-repeat': 'no-repeat',
                    'background-position': 'left bottom',
                    'height': '315px'
                }
            }
        },

        loadMobileBg(){
            return {
                'backgroundImage':'url(../images/mpower-new/background/home/mobile.png)',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
            }
        },
        loadTabletBg(){
            return {
                'backgroundImage':'url(../images/mpower-new/background/home/iPad.png)',
                'background-size': 'cover',
                'background-repeat': 'no-repeat'
            }
        },
        loadOverlapImage(){
            return this.overlapImage
        },
        loadDesc(){
            return this.description
        }
    },
    methods: {
      hideModal() {
        document.querySelector(".header-s").style.display = "block";
        document.querySelector(".header").style.zIndex = "96";
          this.$modal.hide(this.modal)
      },
    }
}
</script>
